import { SET_TEST_ATTEMPT, GET_TEST_ATTEMPT } from "./types";
import firebase from "../firebase";

// Save test attempt when user clicks "Start >>" to prevent difficulty changes
export const saveTestAttempt = (params) => {
  return (dispatch, getState) => {
    const { 
      surveyid, 
      personid, 
      companyID, 
      real_companyID,
      difficulty, 
      maxAttempts,
      attemptNumber = 1
    } = params;

    const isCompanyID = real_companyID || companyID;
    const timestamp = Date.now();
    const attemptId = `${surveyid}_${personid}_${timestamp}`;

    const attemptData = {
      surveyid,
      personid,
      difficulty,
      maxAttempts,
      attemptNumber,
      startedAt: timestamp,
      status: 'started',
      companyID: isCompanyID,
      attemptId
    };

    const updates = {};
    // Store at: testAttempts/{companyID}/{surveyid}/{personid}/
    const path = `testAttempts/${isCompanyID}/${surveyid}/${personid}`;
    updates[path] = attemptData;

    

    return firebase.database
      .ref()
      .update(updates)
      .then(() => {
        
        dispatch({
          type: SET_TEST_ATTEMPT,
          payload: attemptData
        });
        return attemptData;
      })
      .catch(err => {
        
        dispatch({
          type: SET_TEST_ATTEMPT,
          error: err.message
        });
        throw err;
      });
  };
};

// Get existing test attempt to check if difficulty is locked
export const getTestAttempt = (params) => {
  return (dispatch, getState) => {
    const { surveyid, personid, companyID, real_companyID } = params;
    const isCompanyID = real_companyID || companyID;
    const path = `testAttempts/${isCompanyID}/${surveyid}/${personid}`;

    

    return firebase.database
      .ref(path)
      .once('value')
      .then(snapshot => {
        const attemptData = snapshot.val();
        
        if (attemptData) {
          
          
          dispatch({
            type: GET_TEST_ATTEMPT,
            payload: attemptData
          });
          
          return attemptData;
        } else {
          
          dispatch({
            type: GET_TEST_ATTEMPT,
            payload: null
          });
          
          return null;
        }
      })
      .catch(err => {
        
        dispatch({
          type: GET_TEST_ATTEMPT,
          error: err.message
        });
        throw err;
      });
  };
};

// Update test attempt (for retries, completion, etc.)
export const updateTestAttempt = (params) => {
  return (dispatch, getState) => {
    const { 
      surveyid, 
      personid, 
      companyID, 
      real_companyID,
      updates: updateData
    } = params;

    const isCompanyID = real_companyID || companyID;
    const path = `testAttempts/${isCompanyID}/${surveyid}/${personid}`;

    const updates = {};
    Object.keys(updateData).forEach(key => {
      updates[`${path}/${key}`] = updateData[key];
    });

    

    return firebase.database
      .ref()
      .update(updates)
      .then(() => {
        
        dispatch({
          type: SET_TEST_ATTEMPT,
          payload: updateData
        });
        return updateData;
      })
      .catch(err => {
        
        dispatch({
          type: SET_TEST_ATTEMPT,
          error: err.message
        });
        throw err;
      });
  };
};

// Clear test attempt (for cleanup or reset)
export const clearTestAttempt = (params) => {
  return (dispatch, getState) => {
    const { surveyid, personid, companyID, real_companyID } = params;
    const isCompanyID = real_companyID || companyID;
    const path = `testAttempts/${isCompanyID}/${surveyid}/${personid}`;

    

    return firebase.database
      .ref(path)
      .remove()
      .then(() => {
        
        dispatch({
          type: GET_TEST_ATTEMPT,
          payload: null
        });
      })
      .catch(err => {
        
        throw err;
      });
  };
};